import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  EventStatisticsAggregation,
  EventStatisticsQuery,
  PredefinedEventQueryRequest,
  SessionTimeline,
  SessionTimelineRequest
} from '../../models/event-statistics';

@Injectable({
  providedIn: 'root'
})
export class EventStatisticsService {
  protected baseUrl = 'json/events/statistics';
  protected http = inject(HttpClient);

  query(body: EventStatisticsQuery): Observable<EventStatisticsAggregation[]> {
    return this.http.post<EventStatisticsAggregation[]>(this.baseUrl, body);
  }

  queryPredefined(body: PredefinedEventQueryRequest): Observable<EventStatisticsAggregation[]> {
    return this.http.post<EventStatisticsAggregation[]>(`${this.baseUrl}/predefined`, body);
  }

  getEventTypes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/event-types`);
  }

  getSessionTimelines(body: SessionTimelineRequest): Observable<SessionTimeline[]> {
    return this.http.post<SessionTimeline[]>(`${this.baseUrl}/session-timeline`, body);
  }

  getGeneralTimelines(body: SessionTimelineRequest): Observable<SessionTimeline[]> {
    return this.http.post<SessionTimeline[]>(`${this.baseUrl}/session-timeline/general`, body);
  }
}
